import { render, staticRenderFns } from "./alltasks.vue?vue&type=template&id=f8466144&"
import script from "./alltasks.vue?vue&type=script&lang=js&"
export * from "./alltasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports